import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    TemplateRef,
    ViewContainerRef,
    ChangeDetectorRef
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { CreateFeeScheduleDoctorFormComponent } from '../create-fee-schedule-doctor-form/create-fee-schedule-doctor-form.component';
import { CreateFeeScheduleComponent } from '../create-fee-schedule/create-fee-schedule.component';
import { MessagingService } from '../../../services/messaging.service';
import { FeeScheduleService } from '../services/fee-schedule.service';
import { FeeScheduleConfirmComponent } from '../fee-schedule-confirm/fee-schedule-confirm.component';

import { EditFeeScheduleDoctorComponent } from '../edit-fee-schedule-doctor/edit-fee-schedule-doctor.component';
import { EditFeeScheduleComponent } from '../edit-fee-schedule/edit-fee-schedule.component';
import {TdoSearchEvent} from '../../../tdo-controls/common/tdo-search/models/TdoSearchEvent';
import {FeeScheduleDataModel} from '../../../models/fee-schedule/fee-schedule-data.model';
import {FeeScheduleListViewDataModel} from '../models/fee-schedule-list-view.model';
import {FeeScheduleDoctorDataModel} from '../../../models/fee-schedule/fee-schedule-doctor.model';
import {TemplatePortal} from '@angular/cdk/portal';
import {fromEvent, Subscription} from 'rxjs';
import {filter, take} from 'rxjs/operators';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {DialogService} from '../../../services/dialog.service';
import {
    InsuranceNoFeeScheduleDialogComponent
} from '../../insurance/insurance-no-fee-schedule-dialog/insurance-no-fee-schedule-dialog.component';
import {FeeScheduleUpdateProfileComponent} from '../fee-schedule-update-profile/fee-schedule-update-profile.component';
import {ConfirmActionButton, GeneralConfirmComponent} from '../../tdo-shared/general-confirm/general-confirm.component';
import {DxTreeListModule, DxTemplateModule, DxContextMenuComponent} from 'devextreme-angular';
import { DxAccordionComponent } from 'devextreme-angular';

@Component({
    selector: 'app-fee-schedule-list',
    templateUrl: './fee-schedule-list.component.html',
    styleUrls: ['./fee-schedule-list.component.scss'],

})
export class FeeScheduleListComponent implements OnInit {
    @ViewChild('scheduleContextMenu') scheduleContextMenu: TemplateRef<any>;
    @ViewChild('doctorContextMenu') doctorContextMenu: TemplateRef<any>;
    @ViewChild('contextMenu') contextMenu: DxContextMenuComponent;
    @ViewChild(DxAccordionComponent, { static: false }) listFeeScheds: DxAccordionComponent;


    @Input() feeScheduleList: FeeScheduleDataModel[] = [];
    @Input() defaultDoctorId: string;
    @Input() selectedFeeScheduleId: string;
    @Input() selectedDocFeeScheduleID: string;

    @Output() selectFeeSchedule = new EventEmitter<FeeScheduleListViewDataModel>();
    @Output() selectDocFeeSchedule = new EventEmitter<string>();

    isLoading: boolean = false;
    deleteMode: boolean = false;
    feeScheduleListView: FeeScheduleListViewDataModel[] = [];
    feeScheduleListViewBackup: FeeScheduleListViewDataModel[] = [];
    currentScheduleId: string;
    hideByDoctor: boolean = false;
    contextMode: string;
    activeContextDoctor: FeeScheduleDoctorDataModel;
    activeContextSchedule: FeeScheduleListViewDataModel;
    contextPositionX = 0;
    contextPositionY = 0;
    showContext: boolean = false;
    keyword: string;
    resultFound: boolean = false;
    getFeesSubscription: any;
    defaultListItem: FeeScheduleListViewDataModel;
    currentDocFeeScheduleID: string;

    currentFeeshedule: any;
    currentDocFeeSchedule: any ;

    copyDocFee = { origin_DocFeeScheduleID: '',  dest_FeeScheduleID: '', dest_DoctorId: '' , dest_Description: ''};


    private overlayRef: OverlayRef | null;
    private sub: Subscription;

    contextMenuItems: any[] = [];
    contextMenuItemsFeeSched = [
        { text: 'Edit', icon: 'edit',  id: 1  },
        { text: 'Delete', icon: 'trash' ,  id: 2 },
        { separator: true ,  id: 4 },
        { text: 'Update Profile', icon: 'pulldown' ,  id: 3 },
        { separator: true , id: 4 },
        { text: 'Add Doctor Fee', icon: 'plus' , id: 5 },
    ];
    contextMenuItemsDocFeeSched = [
        { text: 'Edit', icon: 'edit', id: 11  },
        { text: 'Delete', icon: 'trash' ,  id: 12 },
        { separator: true , id: 14 },
        { text: 'Copy Doctor Fees', icon: 'copy' , id: 16 },
        { text: 'Paste Doctor Fee', icon: 'paste' ,  id: 17, disabled: true },
        // { separator: true , id: 14 },
        // { text: 'Add Doctor Fee', icon: 'plus' ,  id: 15 },



    ];



    constructor(
        private messagingService: MessagingService,
        private feeScheduleService: FeeScheduleService,
        private dialog: MatDialog,
        private overlay: Overlay,
        private viewContainerRef: ViewContainerRef,
        private dialogService: DialogService,
        private cdr: ChangeDetectorRef
    ) {
        this.defaultListItem = new FeeScheduleListViewDataModel();
        this.defaultListItem.FeeScheduleName = '';
        this.defaultListItem.Selected = false;
        this.defaultListItem.Hovered = false;
        this.defaultListItem.Editable = false;
        this.defaultListItem.dataFeeScheduleDoctors = [];
    }


    ngOnInit() {
        // load feeshedules
        this.isLoading = true;
        this.loadAllFees();


    }
    loadAllFees() {

        this.feeScheduleList = null;
        this.feeScheduleService.getAllFeeSchedules().subscribe(res => {
            this.feeScheduleList = res;
            //console.log('fees list ', this.feeScheduleList);
            this.isLoading = false;




        }, error => {
            console.log('Error', error);
            this.isLoading = false;
        }


        );
    }

    onAccordionReady(e)  {

      //console.log('accodrian complet evet', e);

      //console.log('itewm 4 expended');

      if (this.currentFeeshedule.FeeScheduleID) {
        const i = this.feeScheduleList.findIndex(a => a.FeeScheduleID == this.currentFeeshedule.FeeScheduleID);
        if (i >= 0) {
          //console.log('open accodian item ', i)  ;
          e.component.expandItem(i);
          //console.log('opened ')  ;
        }
      }

    }

    expandAccordionItem(index: number) {
        this.listFeeScheds.instance.expandItem(index);
    }



    xngOnInit() {
        if (this.feeScheduleList) {
            this.mapFeeSchedules(this.feeScheduleList);
        }
    }

    zCount = 0;
    onFeeScedItemClick(e) {
        console.log('Fee shed click ', e) ;

        if ( this.zDocClicked)
        {
            this.zDocClicked = false;
            return;
        }

        const tmpFeeSchedule = new FeeScheduleListViewDataModel();
        tmpFeeSchedule.OrganizationID = e.itemData.OrganizationID;
        tmpFeeSchedule.OrganizationName = e.itemData.OrganizationName;
        tmpFeeSchedule.FeeScheduleID = e.itemData.FeeScheduleID;
        tmpFeeSchedule.FeeScheduleName = e.itemData.FeeScheduleName;

        this.currentFeeshedule = tmpFeeSchedule;

        this.selectFeeSchedule.emit(tmpFeeSchedule);


        this.messagingService.sendComponentMessage('CLEAR_FEE_ITEMS', { });




    }




    zDocClicked = false;
    onDocFeeClick(e)  {
        console.log('doc click', e) ;
        this.zDocClicked = true;

        if (this.currentDocFeeSchedule) {
            this.currentDocFeeSchedule.isSelected = false;
        }

        e.itemData.isSelected = true;
        this.currentDocFeeSchedule =  e.itemData;



        // this.currentDocFeeScheduleID = e.itemData.DocFeeScheduleID;
        // this.selectDocFeeSchedule.emit(e.itemData.DocFeeScheduleID);



        this.messagingService.sendComponentMessage('FEE_SCHEDULE_DOCTOR_CHANGED', { feeScheduleDoctor: e.itemData, feeSchedule: this.currentFeeshedule });


        // return false;
    }

    onEditFeeSchedClick(e) {
        console.log('edit fee schd click ', e) ;
    }

    onContextMenuFeeSchedItemClick(e) {

        console.log('context menu fee schd click ', e) ;

        console.log('step 2');

        if (e.itemData.id === 1) {
            // edit feeshedule name
            this.openEditScheduleComponentV2(this.currentFeeshedule);
        }

        if (e.itemData.id === 2) {
            // delete doctors fgeeschedule
            this.deleteFeeshedule(this.currentFeeshedule);

        }

        if (e.itemData.id === 3) {
            /// update  profiles

            this.UpdateProfileDialogV2(this.currentFeeshedule.OrganizationID, this.currentFeeshedule.FeeScheduleID);


        }
        if (e.itemData.id === 5) {

            // add new doctor sched
            this.addDoctorToScheduleV2(this.currentFeeshedule);

        }

        if (e.itemData.id === 11) {
            this.openEditDoctorComponentV2(this.currentDocFeeSchedule);
        }
        if (e.itemData.id === 12) {
        // delete fgeeschedule
            this.deleteDocFeeshedule(this.currentDocFeeSchedule);

        }

        if (e.itemData.id === 16) {
        // copy  feeschedule
            this.copyDocFee.origin_DocFeeScheduleID = this.activeContextDoctor.DocFeeScheduleID;

            this.contextMenuItemsDocFeeSched.find(f => f.id == 17).disabled = false;


            console.log('this.copyDocFee.origin_DocFeeScheduleID', this.copyDocFee.origin_DocFeeScheduleID);

        }
        if (e.itemData.id === 17) {
        // paste from #16

            if (this.copyDocFee.origin_DocFeeScheduleID) {

                //  this.copyDocFee.dest_DocFeeScheduleID =  get doctor id from popup

                this.pasteAddDoctorFee({FeeScheduleID: this.selectedFeeScheduleId, FeeScheduleName: this.currentFeeshedule.FeeScheduleName });

                // call routine on server with SP to crete


            }


        }







    }

    pasteAddDoctorFee(feeSched: any)  {

        const dialogRef = this.dialog.open(CreateFeeScheduleDoctorFormComponent, {
            panelClass: 'dialog',
            data: {
                FeeScheduleId: feeSched.FeeScheduleID,
                defaultDoctorId: this.defaultDoctorId,
                activeContextFeeSchedule: feeSched,
                titleName: feeSched.FeeScheduleName,
                copyMode: true

            }
        });
        dialogRef.afterClosed().subscribe(result => {

            if (result != false)
            {
                // console.log('Who crete response ', result);

                this.isLoading=true;
                this.messagingService.sendComponentMessage('CLEAR_FEE_ITEMS', { });

                this.feeScheduleService.createFeeScheduleDoctorPaste(
                    this.copyDocFee.origin_DocFeeScheduleID,
                    feeSched.FeeScheduleID,
                    result.DoctorId,
                    result.Description
                ).subscribe(res => {


                    // reload list
                    this.loadAllFees();
                    //console.log('currentFeeshedule ', this.currentFeeshedule);




                    this.copyDocFee.origin_DocFeeScheduleID = null;
                    this.contextMenuItemsDocFeeSched.find(f => f.id == 17).disabled = true;
                    // this.messagingService.sendComponentMessage('INIT_FEE_SCHEDULE', {});

                }, error => {
                  this.isLoading =false;
                  console.log(error);


                  }

                );


            }

        });



    }




    onFeeSchedRightClick(e, i) {

        console.log('right  click ', e, i) ;


        if (i.DocFeeScheduleID) {
            this.contextMenuItems = this.contextMenuItemsDocFeeSched;
            this.activeContextDoctor = i;
        }
        else {
            this.contextMenuItems = this.contextMenuItemsFeeSched;
            this.activeContextDoctor = null;
        }


    }

    printdata(data)  {

        console.log('row data', data) ;

        return 'zzz';

    }

    deleteDocFeeshedule(data: any) {

        let message;
        const doc = data as FeeScheduleDoctorDataModel;
        message = 'Are you sure you want to delete the fee schedule for<br/>' +
                   ` <b> ${doc.Description} </b> ? `;

        this.dialogService.openConfirmDialog(message).subscribe((result) => {
            if (result) {

                this.isLoading = true;

                this.feeScheduleService.setFeeScheduleDoctor(null);
                //  this.messagingService.sendComponentMessage('FEE_SCHEDULE_DOCTOR_CHANGED', { feeScheduleDoctor: null });

                this.currentScheduleId = doc.FeeScheduleID;
                this.feeScheduleService.deleteFeeScheduleDoctor(doc.DocFeeScheduleID)
                    .subscribe(response => {
                        this.currentDocFeeScheduleID = null;
                        this.messagingService.sendComponentMessage('CLEAR_FEE_ITEMS', { feeScheduleDoctor: this.currentDocFeeScheduleID  });
                        this.loadAllFees();
                        // clear current


                        // this.messagingService.sendComponentMessage('INIT_FEE_SCHEDULE', {});
                    }, err => {
                        this.isLoading = false;
                        console.log(err);
                    });


            }
        });
    }




    deleteFeeshedule(data: any) {

        // handleDeleteEvent(data: any, data2: any = null) {
        let message;
        const sched = data as FeeScheduleListViewDataModel;
        message = `Are you sure you want to delete fee schedules: <br/> <b> ${sched.FeeScheduleName} </b> ?  </br>` +
                  'All doctors fee schedules will be deleted as well!<br/>' +
                  'All existing Profiles that use this fee schedule will be affected also !  ';

        this.dialogService.openConfirmDialog(message).subscribe((result) => {
            if (result) {

                this.isLoading = true;
                this.feeScheduleService.removeSchedule(sched.FeeScheduleID)
                    .subscribe(response => {

                        this.loadAllFees();
                        // this.messagingService.sendComponentMessage('DISPLAY_SUCCESS', { message: 'Schedule deleted' });
                        // this.messagingService.sendComponentMessage('INIT_FEE_SCHEDULE', {});
                    }, err => {
                        console.log(err);
                        this.isLoading = false;
                        // this.messagingService.sendComponentMessage('DISPLAY_WARNING', { message: 'Whoops.. something went wrong' });
                    });
            }
        });
    }

    openEditDoctorComponentV2(data: FeeScheduleDoctorDataModel) {

        const dialogRef = this.dialog.open(EditFeeScheduleDoctorComponent, {
            panelClass: 'dialog',
            height: '405px',
            data: {
                dataDoctor: data,
            }
        });
        dialogRef.afterClosed().subscribe(result => {

            if (result) {
                data.Description = result.Description;
                data.ProviderIDbyInsurance = result.ProviderIDbyInsurance;
                data.isActive = result.isActive;
            }
        }, err => {
            console.log('err', err);
        });
    }


    openEditScheduleComponentV2(data: FeeScheduleListViewDataModel) {
        console.log('edit fee sched ', data);
        const dialogRef = this.dialog.open(EditFeeScheduleComponent, {
            panelClass: 'dialog',
            data: {
                feeSchedule: data,
            }
        });
        dialogRef.afterClosed().subscribe(result => {

            if (result) {
                // this.activeContextSchedule.FeeScheduleName = result.FeeScheduleName;

                // this.feeScheduleList.find(f => f.FeeScheduleID === this.currentFeeshedule.FeeScheduleID).FeeScheduleName = result.FeeScheduleName;

                // this.cdr.detectChanges();
                // this.listFeeScheds.instance.dispose();


                // this.listFeeScheds.instance.option('dataSource', this.feeScheduleList);


                this.messagingService.sendComponentMessage('INIT_FEE_SCHEDULE', {});

            } else {
                this.activeContextSchedule = data;
            }
        }, err => {
            console.log('err', err);
        });
    }

    UpdateProfileDialogV2(OrganizationId: string, FeeScheduleId: string) {



        const dialogRef = this.dialog.open(FeeScheduleUpdateProfileComponent, {
            panelClass: 'dialog',
            data: {
                OrganizationID: OrganizationId,
                FeeScheduleID: FeeScheduleId
            }
        });
        dialogRef.afterClosed().subscribe(result => {

        }, err => {
        });
    }

    addDoctorToScheduleV2(feeSched: FeeScheduleListViewDataModel) {



        const activeFeeSchedule: FeeScheduleListViewDataModel = this.feeScheduleListView.find(item => item.FeeScheduleID === feeSched.FeeScheduleID);
        const dialogRef = this.dialog.open(CreateFeeScheduleDoctorFormComponent, {
            panelClass: 'dialog',
            data: {
                FeeScheduleId: feeSched.FeeScheduleID,
                defaultDoctorId: this.defaultDoctorId,
                activeContextFeeSchedule: feeSched,
                titleName: feeSched.FeeScheduleName
            }
        });
        dialogRef.afterClosed().subscribe(result => {

            if (result != false)
            {
                // console.log('Who crete response ', result);

                this.feeScheduleService.createFeeScheduleDoctor(
                    result.FeeScheduleID,
                    result.DoctorId,
                    result.Description
                ).subscribe(res => {

                    this.messagingService.sendComponentMessage('INIT_FEE_SCHEDULE', {});

                });


            }









        }
        );

    }



    /*
      this.openFeeScheduleDoctorFormV2(item.FeeScheduleID)
            .then((result: any) => {

                if (result) {
                    this.messagingService.sendComponentMessage('FEE_SCHEDULE_LOADING', { isLoading: true });

                    this.feeScheduleService.createFeeScheduleDoctor (
                        result.FeeScheduleID,
                        result.DoctorId,
                        result.Description
                    )
                        .subscribe(responseDoctor => {

                            item.dataFeeScheduleDoctors.push(responseDoctor);
                            this.messagingService.sendComponentMessage('FEE_SCHEDULE_LOADING', { isLoading: false });

                        }, err => {
                            this.messagingService.sendComponentMessage('FEE_SCHEDULE_LOADING', { isLoading: false });
                            console.log(err);
                        });
                }
            }, err => {
                console.log(err);
            });
    }
*/

    openFeeScheduleDoctorFormV2(FeeScheduleID: string) {

        // fee schedule to pass
        const activeFeeSchedule: FeeScheduleListViewDataModel = this.feeScheduleListView.find(item => item.FeeScheduleID === FeeScheduleID);
        const dialogRef = this.dialog.open(CreateFeeScheduleDoctorFormComponent, {
            panelClass: 'dialog',
            data: {
                FeeScheduleId: FeeScheduleID,
                defaultDoctorId: this.defaultDoctorId,
                activeContextFeeSchedule: activeFeeSchedule,
                titleName: activeFeeSchedule.FeeScheduleName
            }
        });

        dialogRef.afterClosed().subscribe(result => {

        }, err => {

        });



    }





    //* ********************************************************
    toggleHideFeesWithoutDoctors() {
        if (this.hideByDoctor) {
            this.feeScheduleListView = this.feeScheduleListView.filter(listItem => listItem.dataFeeScheduleDoctors.length > 0);
            this.feeScheduleListView.forEach(listItem => {
                listItem.Selected = true;
            });
        } else {
            this.feeScheduleListView = JSON.parse(JSON.stringify(this.feeScheduleListViewBackup));
        }
    }

    onRightClickScheduleEvent(event, schedule: FeeScheduleListViewDataModel) {
        this.contextMode = 'schedule';
        this.contextPositionX = event.clientX;
        this.contextPositionY = event.clientY;
        this.activeContextSchedule = schedule;
        this.showContext = true;
    }

    onRightClickDoctorEvent(event, doctor: FeeScheduleDoctorDataModel, schedule: FeeScheduleListViewDataModel) {
        this.contextMode = 'doctor';
        this.contextPositionX = event.clientX;
        this.contextPositionY = event.clientY;
        this.activeContextDoctor = doctor;
        this.activeContextSchedule = schedule;
        this.showContext = true;
    }

    handleDeleteEvent(data: any, data2: any = null) {
        let message;
        const sched = data as FeeScheduleListViewDataModel;
        if (!data2) {
            message = `Are you sure you want to delete the fee schedule ${sched.FeeScheduleName}? <br/> All doctor fee schedules will be deleted as well.<br/>  All existing Profiles that use this fee schedule will be affected also !  `;
        } else {
            const doc = data2 as FeeScheduleDoctorDataModel;
            message = `Are you sure you want to delete the fee schedule for ${doc.Description}?`;
        }

        this.dialogService.openConfirmDialog(message).subscribe((result) => {
            if (result) {
                if (!data2) {
                    this.deleteSchedule(data);
                } else {
                    this.deleteDoctor(data, data2);
                }
            }
        });
    }

    handleEditEvent(data: any) {
        console.log('test');
        if (data instanceof FeeScheduleListViewDataModel) {
            this.openEditScheduleComponent(data);
        } else {
            this.openEditDoctorComponent(data);
        }
    }

    handleUpdateEvent(data: any) {
        console.log('update event clicked');
        if (data instanceof FeeScheduleListViewDataModel) {
            this.UpdateProfileDialog(data.OrganizationID, data.FeeScheduleID);
            // this.openEditScheduleComponent(data);
        } else {
            // this.openEditDoctorComponent(data);
        }
    }

    openEditDoctorComponent(data: FeeScheduleDoctorDataModel) {



        const dialogRef = this.dialog.open(EditFeeScheduleDoctorComponent, {
            panelClass: 'dialog',
            height: '330px',
            data: {
                dataDoctor: data,
            }
        });
        dialogRef.afterClosed().subscribe(result => {

            if (result) {
                data.Description = result.Description;
                data.ProviderIDbyInsurance = result.ProviderIDbyInsurance;
                data.isActive = result.isActive;
            }
        }, err => {
            console.log('err', err);
        });
    }

    openEditScheduleComponent(data: FeeScheduleListViewDataModel) {
        const dialogRef = this.dialog.open(EditFeeScheduleComponent, {
            panelClass: 'dialog',
            data: {
                feeSchedule: data,
            }
        });
        dialogRef.afterClosed().subscribe(result => {

            if (result) {
                this.activeContextSchedule.FeeScheduleName = result.FeeScheduleName;
                this.messagingService.sendComponentMessage('INIT_FEE_SCHEDULE', {});
            } else {
                this.activeContextSchedule = data;
            }
        }, err => {
            console.log('err', err);
        });
    }

    hideContextMenu() {
        this.showContext = false;
    }

    handleCopyDoctorEvent(data: any, data1: any) {
        this.showContext = false;
        const promise = new Promise((resolve, reject) => {

            const dialogRef = this.dialog.open(CreateFeeScheduleDoctorFormComponent, {
                panelClass: 'dialog',
                data: {
                    FeeScheduleId: data.FeeScheduleID,
                    titleName: data.FeeScheduleName,
                    defaultDoctorId: this.defaultDoctorId,
                    docFeeScheduleId: data1.DocFeeScheduleID,
                    copyMode: true,
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                this.messagingService.sendComponentMessage('FEE_SCHEDULE_LOADING', { isLoading: true });
                this.feeScheduleService.copyFeeScheduleDoctor(result.FeeScheduleID, result.DoctorId, result.Description, result.DocFeeScheduleID)
                    .subscribe(response => {

                        // doc fee schedule copied
                        response = response;
                        this.messagingService.sendComponentMessage('FEE_SCHEDULE_LOADING', { isLoading: false });
                        this.messagingService.sendComponentMessage('INIT_FEE_SCHEDULE', {});
                    }, err => {
                        this.messagingService.sendComponentMessage('FEE_SCHEDULE_LOADING', { isLoading: false });
                    });
            }, err => {
                reject(err);
            });
        });

        return promise;
    }

    showFeeScheduleDoctors(listItem: FeeScheduleListViewDataModel) {
        listItem.Selected = !listItem.Selected;
        if (listItem.Selected) {
            const tmpFeeSchedule = new FeeScheduleListViewDataModel();
            tmpFeeSchedule.OrganizationID = listItem.OrganizationID;
            tmpFeeSchedule.FeeScheduleID = listItem.FeeScheduleID;

            this.selectFeeSchedule.emit(tmpFeeSchedule);
        }
    }

    mapFeeSchedules(feeSchedules: FeeScheduleDataModel[]) {
        this.feeScheduleListView = [];
        feeSchedules.forEach(schedule => {

            const feeSchedule: FeeScheduleListViewDataModel = new FeeScheduleListViewDataModel();
            feeSchedule.Selected = false;
            feeSchedule.Hovered = false;
            feeSchedule.Editable = false;
            feeSchedule.dataFeeScheduleDoctors = schedule.dataFeeScheduleDoctors;
            feeSchedule.FeeScheduleName = schedule.FeeScheduleName;
            feeSchedule.FeeScheduleID = schedule.FeeScheduleID;
            feeSchedule.OrganizationID = schedule.OrganizationID;
            this.feeScheduleListView.push(feeSchedule);
        });
        this.feeScheduleListView = this.feeScheduleListView.sort((a, b) => {
            if (a.FeeScheduleName < b.FeeScheduleName) { return -1; }
            if (a.FeeScheduleName > b.FeeScheduleName) { return 1; }
            return 0;
        });

        if (this.selectedFeeScheduleId) {
            this.feeScheduleListView.forEach(item => {
                if (item.FeeScheduleID === this.selectedFeeScheduleId) {
                    item.Selected = true;
                }
            });
        }

        this.feeScheduleListViewBackup = JSON.parse(JSON.stringify(this.feeScheduleListView));
    }

    search(event: TdoSearchEvent) {
        const keyword = event.value;
        this.messagingService.sendComponentMessage('CLEAR_FEE_ITEMS', { clear: true });

        if (!this.resultFound) {
            this.feeScheduleListView = JSON.parse(JSON.stringify(this.feeScheduleListViewBackup));
        }

        if (keyword.trim() === '') {
            this.feeScheduleListView = JSON.parse(JSON.stringify(this.feeScheduleListViewBackup));
            return;
        }

        this.feeScheduleListView = this.feeScheduleListView.filter(element => {
            if (element.FeeScheduleName.toLowerCase().includes(keyword.toLowerCase())) {
                element.Selected = true;
                return true;
            } else {
                let flag = false;
                element.dataFeeScheduleDoctors.forEach(doctor => {
                    if (doctor.Description.toLowerCase().includes(keyword.toLowerCase())) {
                        flag = true;
                    }
                });
                if (flag) {
                    element.Selected = true;
                }
                return flag;
            }
        });

        if (this.feeScheduleListView.length) {
            this.resultFound = true;
        } else {
            this.resultFound = false;
        }
    }


    openFeeScheduleDoctorForm(FeeScheduleID: string) {

        // fee schedule to pass
        const activeFeeSchedule: FeeScheduleListViewDataModel = this.feeScheduleListView.find(item => item.FeeScheduleID === FeeScheduleID);

        const promise = new Promise((resolve, reject) => {

            const dialogRef = this.dialog.open(CreateFeeScheduleDoctorFormComponent, {
                panelClass: 'dialog',
                data: {
                    FeeScheduleId: FeeScheduleID,
                    defaultDoctorId: this.defaultDoctorId,
                    activeContextFeeSchedule: activeFeeSchedule,
                    titleName: activeFeeSchedule.FeeScheduleName
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                resolve(result);
            }, err => {
                reject(err);
            });
        });

        return promise;
    }

    openCreateFeeScheduleForm() {
        const dialogRef = this.dialog.open(CreateFeeScheduleComponent, {
            width: '500px',
            height: '320px',
            data: {}
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result && result.feeSchedule) {
                this.messagingService.sendComponentMessage('INIT_FEE_SCHEDULE', {});
            }
        });
    }

    addDoctorToSchedule(item: FeeScheduleListViewDataModel) {
        this.openFeeScheduleDoctorForm(item.FeeScheduleID)
            .then((result: any) => {

                if (result) {
                    this.messagingService.sendComponentMessage('FEE_SCHEDULE_LOADING', { isLoading: true });

                    this.feeScheduleService.createFeeScheduleDoctor (
                        result.FeeScheduleID,
                        result.DoctorId,
                        result.Description
                    )
                        .subscribe(responseDoctor => {

                            item.dataFeeScheduleDoctors.push(responseDoctor);
                            this.messagingService.sendComponentMessage('FEE_SCHEDULE_LOADING', { isLoading: false });

                        }, err => {
                            this.messagingService.sendComponentMessage('FEE_SCHEDULE_LOADING', { isLoading: false });
                            console.log(err);
                        });
                }
            }, err => {
                console.log(err);
            });
    }

    selectFeeScheduleDoctor(selectedFeeSchedule: FeeScheduleListViewDataModel, selectedDoctor: FeeScheduleDoctorDataModel) {

        this.selectDocFeeSchedule.emit(selectedDoctor.DocFeeScheduleID);
        this.currentDocFeeScheduleID = selectedDoctor.DocFeeScheduleID;

        this.messagingService.sendComponentMessage('SELECTED_FEE_SCHEDULE_CHANGES', { feeSchedule: selectedFeeSchedule });
        this.messagingService.sendComponentMessage('FEE_LIST_LOADING', { isLoading: true });

        if (this.getFeesSubscription) {
            this.getFeesSubscription.unsubscribe();
            this.getFeesSubscription = false;
        }

        // this.getFeesSubscription = this.feeScheduleService.getFeeScheduleDoctorById(selectedDoctor.DocFeeScheduleID)
        //      .subscribe(response => {
        this.getFeesSubscription = false;
        this.messagingService.sendComponentMessage('FEE_LIST_LOADING', { isLoading: false });
        // if (response) {
        if (selectedDoctor){
            this.feeScheduleService.setFeeScheduleDoctor(selectedDoctor);
            this.messagingService.sendComponentMessage('FEE_SCHEDULE_DOCTOR_CHANGED', { feeScheduleDoctor: selectedDoctor });
        }
        // }, err => {
        //   this.messagingService.sendComponentMessage('FEE_LIST_LOADING', { isLoading: false });
        //   this.getFeesSubscription = false;
        //   console.log(err);
        // });
    }

    deleteDoctor(feeSchedule: FeeScheduleListViewDataModel, doctor: FeeScheduleDoctorDataModel) {

        feeSchedule.dataFeeScheduleDoctors = feeSchedule.dataFeeScheduleDoctors.filter(d => d.DocFeeScheduleID !== doctor.DocFeeScheduleID);

        this.feeScheduleService.setFeeScheduleDoctor(null);
        this.messagingService.sendComponentMessage('FEE_SCHEDULE_DOCTOR_CHANGED', { feeScheduleDoctor: null });

        this.isLoading = true;
        this.feeScheduleService.deleteFeeScheduleDoctor(doctor.DocFeeScheduleID)
            .subscribe(response => {
                this.loadAllFees();
                // set current ?
                // doctor.FeeScheduleID

            }, err => {
                this.isLoading = false;
                console.log(err);
            });
    }

    toggleDeleteFeeSchedule(mode) {
        this.deleteMode = mode;
    }

    deleteSchedule(feeSchedule: FeeScheduleListViewDataModel) {
        this.feeScheduleListView = this.feeScheduleListView.filter(schedule => schedule.FeeScheduleID !== feeSchedule.FeeScheduleID);
        this.feeScheduleService.removeSchedule(feeSchedule.FeeScheduleID)
            .subscribe(response => {
                this.messagingService.sendComponentMessage('DISPLAY_SUCCESS', { message: 'Schedule deleted' });
                this.messagingService.sendComponentMessage('INIT_FEE_SCHEDULE', {});
            }, err => {
                console.log(err);
                this.messagingService.sendComponentMessage('DISPLAY_WARNING', { message: 'Whoops.. something went wrong' });
            });
    }

    onOpenContextMenu(event: MouseEvent, data: any, data1: any = null) {
        if (!data1) {
            this.openContext(event, this.scheduleContextMenu, data);
        } else {
            this.openContext(event, this.doctorContextMenu, data, data1);
        }
    }

    openContext({x, y}: MouseEvent, template: TemplateRef<any>, data: any, data1: any = null, closeOnItemClick = true): void {
        this.closeContext();
        x = x + 100;
        y = y - 20;
        const positionStrategy = this.overlay.position().flexibleConnectedTo({x, y}).withPositions([
            {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top'
            }
        ]);

        this.overlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.close()
        });

        this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, {$implicit: data, data1}));

        this.sub = fromEvent<MouseEvent>(document, 'click')
            .pipe(
                filter(event => {
                    if (closeOnItemClick) {
                        this.closeContext();
                    } else {
                        const clickTarget = event.target as HTMLElement;
                        return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
                    }
                }), take(1)).subscribe(() => this.closeContext());
    }

    closeContext(): void {
        this.sub !== undefined && this.sub.unsubscribe();
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
    }

    UpdateProfileDialog(OrganizationId: string, FeeScheduleId: string) {
        const dialogRef = this.dialog.open(FeeScheduleUpdateProfileComponent, {
            panelClass: 'dialog',
            data: {
                OrganizationID: OrganizationId,
                FeeScheduleID: FeeScheduleId
            }
        });
        dialogRef.afterClosed().subscribe(result => {

        }, err => {
        });
    }


    onNewFeeSchedule() {
        const dialogRef = this.dialog.open(CreateFeeScheduleComponent, {
            panelClass: 'dialog',
            data: {}
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result && result.feeSchedule) {
                this.messagingService.sendComponentMessage('INIT_FEE_SCHEDULE', {});
            }
        });
    }


}
